import React from 'react'
import Navbar from "./Navbar"
import SearchBar from './SearchBar'
import Filters from './Filters'
import FamilyCard from './familyCard'
import Footer from './Footer'
import "../css/family.css"
import "../css/familyCard.css"
import {useState, useEffect} from 'react';
import axios from "axios";
import {useParams } from 'react-router-dom';
import image from '../images';
import { NavLink } from 'react-router-dom'

function Family() {


    const params  = useParams()
    const category = params.category
    

    const [pets, setPets] = useState([]);
    const [dataFromChild, setDataFromChild] = useState({});


  
   
  

    const filteredData = (data) => {
      setDataFromChild(data);
    };


    
    const search = searchPets(pets, dataFromChild);

    function searchPets(pet,petObject) {
        let newfilterarray = [];
        for (let i = 0; i < pet.length; i++) {
          let sex = petObject.sex;
            let petsex = pet[i].sex;

            let breed = petObject.breed;
            let petbreed = pet[i].breed;

            
            let age = petObject.age;
            let petage = pet[i].age;

            
            let trained = petObject.trained;
            let pettrained = pet[i].trained;

            
            let neutered = petObject.neutered;
            let petneutered = pet[i].neutered;

            let vaccinated = petObject.vaccinated;
            let petvaccinated = pet[i].vaccinated;

            
            if ((petsex.includes(sex)) && (petbreed.includes(breed)) && (petage.includes(age)) && (pettrained.includes(trained)) && (petneutered.includes(neutered)) && (petvaccinated.includes(vaccinated)) || (!sex && !breed && !age && !trained && !neutered && !vaccinated))
                newfilterarray.push(pet[i]);
        }
        return newfilterarray;
    }


  
  
    useEffect(() => {

    

        const fetchPets = async () => {
          try {
            const response = await axios.get(`https://petme.onrender.com/api/pets/petcategory?petcategory=${category}&&verified=true`);
            setPets(response.data);
          } catch (error) {
            console.error(error);
          }
          
        };
        fetchPets();
    
  
    }, []);

    return (
        <div>
            <Navbar />
            <div className="filter">

            {/* <form action="" className="searchbar" >
                <i class="fa-solid fa-paw search-paw"></i>
                <input type="text" name="search" className="search-pet-box" placeholder="search cat, dog, breed, etc..." onChange={(e)=>{setSearchInput(e.target.value)}} />
                <h4 className="search-line">|</h4>
                <i id="search-location-icon" className="searchbar-locationIcon fa-solid fa-location-dot"></i>
                <input type="text" name="search" className="search-location-box" placeholder="enter city or pincode..." onChange={(e)=>{setLocation(e.target.value)}} />
            </form> */}

            {/* Donation Btn */}

            <NavLink className="searchBar-donationBtn-link" to="/supportus" >
                <button className="searchBar-donationBtn">Support Us<img className="searchBar-donationImg" src={image.donationImg} alt="animals-profile" /></button>
            </NavLink>

            </div>

            <div className="row filter-family-row">
                <div className="filters-style">
                <Filters filteredData = {filteredData} searchdata={pets} />
                </div>
                <div className="col">
                    <section id="family"  >
                        <div class="row family-row">

                                {search.map((pet) => (
                                    <div className="family-box col-lg-4 col-md-6" >
                                    <FamilyCard pet ={pet} />
                                      </div>
                                ))}
                        </div>

                    </section>

                </div>
            </div>
            <Footer />
        </div >
    )
}

export default Family